import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class IndexService {

  private readonly http = inject(HttpClient);

  /**
   * Recupera la lista degli indici (paginata)
   */
  getIndexList(pageIndex: number, pageSize: number, sortBy: string, indexFilter: string): Observable<any> {
    let params = new HttpParams()
      .set('pageIndex', pageIndex)
      .set('pageSize', pageSize)
      .set('sortBy', sortBy)
  
    if(indexFilter !== ''){
        Object.entries(indexFilter).forEach(([key, value]) => {
          if(value){
            params = params.set('search', value);
            console.log("params", params);
          }
        });
     }
    return this.http.get<any>(`${environment.api.host_path}/index/list`, { params });
  }

  /**
   * Recupera tutti gli indici (non paginato)
   */
  getAllIndexes(): Observable<any> {
    return this.http.get<any>(`${environment.api.host_path}/index/listAll`);
  }

  /**
   * Crea un nuovo indice
   */
  addNewIndex(indexData: any): Observable<any> {
    return this.http.post(`${environment.api.host_path}/index`, indexData);
  }

  /**
   * Modifica un indice esistente
   */
  editIndex(indexData: any): Observable<any> {
    return this.http.put(`${environment.api.host_path}/index`, indexData);
  }

  /**
   * Cancella un indice dato l'id
   */
  deleteIndex(id: number): Observable<any> {
    return this.http.delete(`${environment.api.host_path}/index/${id}`);
  }

  /**
   * Mock API – Reindicizza un indice
   */
  reindexIndex(id: string): Observable<any> {
    console.log(`Chiamata API: Reindicizza ${id}`);
    return of({ success: true });
  }

  /**
   * Mock API – Refresh singolo indice
   */
  refreshIndex(id: string): Observable<any> {
    console.log(`Chiamata API: Refresh ${id}`);
    return of({ success: true });
  }

  /**
   * Mock API – Refresh di tutti gli indici
   */
  refreshAllIndexes(): Observable<any> {
    console.log(`Chiamata API: Refresh di tutti gli indici`);
    return of({ success: true });
  }

  /**
   * Alias semplificati per componenti UI
   */
  refresh(): Observable<any> {
    return this.refreshIndex('default');
  }

  reindex(): Observable<any> {
    return this.reindexIndex('default');
  }

  refreshAll(): Observable<any> {
    return this.refreshAllIndexes();
  }

  /**
   * Mock API – Ricarica i dati
   */
  reloadData(): Observable<any> {
    console.log('Chiamata API: Ricarica dati');
    return of({
      primaryIndexes: [{ id: 'index_feed' }, { id: 'index_web' }],
      secondaryIndexes: [
        { id: 'index_feed', elasticId: 'index_feedxml-000001', date: '06/02/2023' },
        { id: 'index_web', elasticId: 'index_web-000001', date: '11/07/2022' }
      ],
      activeAliases: [{ id: 'jsoningester' }, { id: 'default' }],
      inactiveAliases: [{ id: 'testalias' }],
      metaFields: [{ field: 'host', type: 'automatic' }]
    });
  }
}
